import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/WechatIMG6281.jpg'


const _withScopeId = n => (_pushScopeId("data-v-168138e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-bar-menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "首页推荐", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的活动", -1))
const _hoisted_4 = { class: "tab-bar-account-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"max-width":"400px"},
  alt: ""
}, null, -1))
const _hoisted_6 = {
  href: "tencent://message/?uin=815612109",
  target: "_blank"
}

import {
  HomeFilled,
  GiftFilled,
  DownOutlined,
  CreditCardOutlined,
  LogoutOutlined,
  CloseOutlined,
  QqOutlined, WechatOutlined
} from '@ant-design/icons-vue'
import LogoView from "@/components/LogoView.vue";
import {browserId} from "@/lib/session";
import {account, IExpPackage} from "@/app/login";
import {req, IconFont} from "@/lib/util";
import {router} from "@/app";
import {reactive} from "vue";
import PurchaseBox from "@/components/views/PurchaseBox.vue";
import PopupBase from "@/components/PopupBase.vue";
import dayjs from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabBarView',
  setup(__props) {

const info = reactive({exp_package: {open: false, info: null as null | IExpPackage}, buy: {open: false}, reg: false})

const onLogout = () => {
  req({
    url: 'account/logout', success: () => {
      account.shop = null
      account.user = null
      router.push('/login')
    }
  })
}

const showExpPackage = (expPackage: IExpPackage) => {
  info.exp_package.info = expPackage
  info.exp_package.open = true
}

const showBuy = () => {
  info.buy.open = true
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_a_menu_item_group = _resolveComponent("a-menu-item-group")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LogoView),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: _normalizeClass({active:_ctx.$route.path == '/'})
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(HomeFilled)),
          _hoisted_2
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/activities",
        class: _normalizeClass({active:_ctx.$route.path.includes('activit')})
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(GiftFilled)),
          _hoisted_3
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _createVNode(_component_a_flex, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_dropdown, {
          arrow: true,
          placement: "bottomRight"
        }, {
          overlay: _withCtx(() => [
            _createVNode(_component_a_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, { disabled: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("ID:" + _toDisplayString(_unref(browserId)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_divider, { type: "divider" }),
                _createVNode(_component_a_menu_item_group, { title: "活动服务包" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(account).exp_packages, (c) => {
                      return (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: c.exp_package_id,
                        onClick: ($event: any) => (showExpPackage(c))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(CreditCardOutlined))
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString(c.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_divider, { type: "divider" }),
                _createVNode(_component_a_menu_item, { onClick: showBuy }, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(IconFont), { type: "icon-goumai" })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" 购买活动服务包 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_divider, { type: "divider" }),
                _createVNode(_component_a_menu_item, { onClick: onLogout }, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(LogoutOutlined))
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" 退出 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "tab-bar-account",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createVNode(_component_a_avatar, { size: 40 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(account).shop?.shop_name[0]), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, _toDisplayString(_unref(account).shop?.shop_name), 1),
                _createElementVNode("div", null, _toDisplayString(_unref(account).shop?.phone_number), 1)
              ]),
              _createVNode(_unref(DownOutlined))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      open: info.exp_package.open,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((info.exp_package.open) = $event)),
      keyboard: "",
      footer: null,
      title: info.exp_package.info?.title,
      width: "680px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, {
          bordered: "",
          size: "middle",
          column: 2
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "ID" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(info.exp_package.info?.exp_package_id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "活动服务次数" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(info.exp_package.info?.times), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "剩余次数" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(info.exp_package.info?.balance), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "有效期" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(dayjs)(info.exp_package.info?.expire_at).format('YYYY年MM月DD日')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open", "title"]),
    _createVNode(PopupBase, {
      open: info.reg,
      "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((info.reg) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(CloseOutlined), {
          style: {"position":"absolute","top":"14px","right":"14px","color":"white"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (info.reg=false))
        }),
        _hoisted_5
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(PurchaseBox, {
      open: info.buy.open,
      "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((info.buy.open) = $event))
    }, null, 8, ["open"]),
    _createVNode(_component_a_flex, {
      vertical: "",
      class: "contact-us",
      gap: "middle"
    }, {
      default: _withCtx(() => [
        _createElementVNode("a", _hoisted_6, [
          _createVNode(_component_a_button, {
            shape: "circle",
            size: "large"
          }, {
            icon: _withCtx(() => [
              _createVNode(_unref(QqOutlined))
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_button, {
          shape: "circle",
          size: "large",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (info.reg=true))
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(WechatOutlined))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})